import type { FeatureName } from "@/types";

export const activeFlags: FeatureName[] = [
    "isgmailaddonenabled",
    "isElementHidingEnabled",
    "isBuiltInChatHidden",
    "isOrderManagementContractsEnabled",
    "isMoRBuyersCreditLimitFeatureEnabled",
    "isDocumentStoreBetaEnabled",
    "isOrderManagementOnlyOrderFlowEnabled",
    "isUsLocalisationEnabled",
    "isOtifTrackingEnabled",
    "isAllianzAPIHookupEnabled",
    "isBuyerOrderRequestsEnabled",
    "isBuyerSupplierPairPaymentTermsEnabled",
    "isIssueRefundEnabled",
    "areOpplyDocumentsVisibleToBuyers",
    "isMorTasksNotesEnabled",
    "isNewBuyerCreditLimitViewEnabled",
    "isCreditCheckerEnabled",
    "isPushOrderToTwoEnabled",
    "isMorOrderRequestsEnabled",
    "isBuyerCreditLimitDashboardEnabled",
    "isOrderTimelineEnabled",
    "tasksEnhancementEnabled",
    "hideViewInvoice",
    "isMorCreditNotesEnabled",
    "isMorGroupedStatementsEnabled",
    "masqueradeToNewBuyer",
    "masqueradeIsolatedOrigin",
    "isNewMorDashboardEnabled",
    "isOrdersMigrationEnabled",
    "isFlattenedMORNavEnabled",
    "isMorOrderManagementContractsMigrationEnabled",
    "isNewMorStatementsEnabled",
    "isMorContractsMigrationEnabled",
    "isMorSuppliersMigrationEnabled",
    "isMorBuyersMigrationEnabled",
    "showUsSaleTax",
];
